import { Button, Group, Div, Text } from '@vkontakte/vkui';
import PropTypes from 'prop-types';
import PaymentTypeComponent from './PaymentTypeComponent';
import RepaymentTypeComponent from './RepaymentTypeComponent';
import { UserAvatar } from '../../components/UserAvatar';
import { getRoutePaymentInfo, getRouteRepaymentInfo } from '../../../route';
import { useAppContext } from '../../../AppContext';
const ITEM_TYPE_PAYMENT = 'payment';

export const ItemNameBlock = ({user, title}) => {
  return (<div className={'UserMiniBlock'}>
    <UserAvatar type={user.type} size={24} src={user.img} name={user.name} id={user.id} />
    <Text weight={'2'} className={'UserMiniBlock__name'}>{title}</Text>
  </div>);
}

const ItemComponent = ({item, users, onClickPayment, onClickRepayment}) => {
  if (item.type === ITEM_TYPE_PAYMENT) {
    return (<PaymentTypeComponent {...item} users={users} onClick={onClickPayment}/>);
  }

  return (<RepaymentTypeComponent {...item} users={users} onClick={onClickRepayment}/>);
}

export const ItemsBlockComponent = ({eventId, items, users, itemsTotalCount, loading, loadItemsButtonLabel, onClickLoadMore}) => {
  const context = useAppContext();

  return (<Group separator={'hide'}>
    {
      items.map((item) => (<ItemComponent
        key={item.type + item.id}
        item={item}
        users={users}
        onClickPayment={() => context.router.push(...getRoutePaymentInfo(item.id, eventId))}
        onClickRepayment={() => context.router.push(...getRouteRepaymentInfo(item.id, eventId))}
      />))
    }
    {
      !items.length && loading ? (<Div><Button stretched={true} mode="tertiary" loading={true}></Button></Div>): undefined
    }
    {
      itemsTotalCount > items.length ? (<Div><Button stretched={true} mode="tertiary" loading={loading} onClick={() => onClickLoadMore()}>{loadItemsButtonLabel}</Button></Div>): undefined
    }
  </Group>);
}

ItemsBlockComponent.propTypes = {
  eventId: PropTypes.number.isRequired,
  errorTextNotFoundItems: PropTypes.string.isRequired,
  loadItemsButtonLabel: PropTypes.string.isRequired,
};
